import { Component, Input, Output, EventEmitter, ChangeDetectionStrategy } from "@angular/core";
import { ButtonColor } from "../button/button.component";

@Component({
    selector: "app-setting-row",
    templateUrl: "./setting-row.component.html",
    styleUrls: ["./setting-row.component.scss"],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class SettingRowComponent {
  @Input() title: string = "Title";
  @Input() headerFieldName: string = "headerFieldName";
  @Input() description: string = "Description";
  @Input() iconKey: string = "cog";
  @Input() buttonLabel: string = "Configure";
  @Input() buttonColor: ButtonColor = "green-outline";
  @Input() buttonIcon: string = "pencil";
  @Input() configured: boolean = false;
  @Input() reviewed: boolean = false;
  @Input() statusType: string = "configure";
  @Output() buttonAction = new EventEmitter<void>();

  getIconClass(): string {
    return `fa fa-${this.iconKey}`;
  }

  getButtonLabel(): string {
    switch (this.statusType) {
      case "review":
        return this.reviewed ? "Reviewed" : "Review";
      case "configure":
        return this.configured ? "Configured" : "Configure";
      default:
        return this.buttonLabel;
    }
  }

  getButtonColor(): ButtonColor {
    switch (this.statusType) {
      case "review":
        return this.reviewed
          ? "green-filled"
          : this.configured
          ? "green-outline"
          : "grey-outline";
      case "configure":
        return this.configured ? "green-filled" : "green-outline";
      default:
        return this.buttonColor;
    }
  }

  getButtonIconClass(): string {
    switch (this.statusType) {
      case "review":
        return this.reviewed ? "fa fa-check" : "fa fa-star-o";
      case "configure":
        return this.configured ? "fa fa-check" : "fa fa-pencil";
      default:
        return `fa fa-${this.buttonIcon}`;
    }
  }

  onButtonClick(): void {
    this.buttonAction.emit();
  }
}
